import VSkeletonLoader from './VSkeletonLoader'

export { VSkeletonLoader }
export default VSkeletonLoader
